//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {Stack} from '@mui/material';
import {asset_atom, exchange_name_atom} from 'atoms';
import {prevent_scroll} from 'common';
import {Footer} from 'components/layout/Footer';
import {Header} from 'components/layout/Header';
import Layout from 'components/layout/Layout';
import TwoDeckContainer from 'components/layout/TwoDeckContainer';
import MarketInfoBox from 'components/MarketInfoBox';
import NavButton from 'components/NavButton';
import ActiveOrderListBox from 'components/order/OrderListBoxActive';
import OrderMaker from 'components/order/OrderMaker';
import PullToRefreshBox from 'components/PullToRefreshBox';
import TVChartBox from 'components/TVChartBox';
import {useActiveOrders} from 'hooks/orderHooks';
import {Fragment} from 'react/jsx-runtime';
import {useRecoilValue} from 'recoil';

//---------------------------------------------------------
// Component
//---------------------------------------------------------
function Market(props: {exchange: string; asset: string; order_list: any[]}) {
	const {exchange, asset, order_list} = props;

	return (
		<Stack width="100%" spacing={2}>
			<TVChartBox exchange={exchange === 'mock' ? 'upbit' : exchange} ticker={asset} />
			<OrderMaker exchange={exchange} ticker={asset} disabled={order_list.filter(order => !order.archived).length >= 10} />
		</Stack>
	);
}

function Order() {
	return (
		<Fragment>
			<ActiveOrderListBox />
			<NavButton type="HISTORY" />
		</Fragment>
	);
}

export default function HomePage() {
	const exchange = useRecoilValue(exchange_name_atom);
	const asset = useRecoilValue(asset_atom);

	const {refresh_orders, order_list} = useActiveOrders();

	return (
		<Layout header={Header} footer={Footer}>
			<Stack id="trade" bgcolor="#020202" width="100%" height="100%" spacing={1} sx={prevent_scroll} alignItems="center" py={1}>
				<TwoDeckContainer left_side_child={<MarketInfoBox exchange={exchange} ticker={asset} />} />

				<PullToRefreshBox onRefresh={refresh_orders}>
					<TwoDeckContainer left_side_child={<Market exchange={exchange} asset={asset} order_list={order_list} />} right_side_child={<Order />} />
				</PullToRefreshBox>
			</Stack>
		</Layout>
	);
}
